<div class="benin-topbar">
  <a href="/">
    <img src="assets/imgs/Zumeralogo-WHITE.png" alt="Zumera" class="benin-topbar__logo" />
  </a>
</div>

<main #pageWrapper class="figma-benin-city-page">
  <section class="benin-hero">
    <div class="benin-hero__img" [style.background-image]="'url(' + assets.heroSkyline + ')'"></div>
    <div class="benin-hero__overlay"></div>
    <div class="benin-hero__content">
      <h1>The Journey to Revealing <br class="benin-hero__br">Africa's Power, Freedom and <br class="benin-hero__br">Beauty to the World.</h1>
    </div>
    <div class="benin-hero__scroll-cue" aria-hidden="true">
      <!-- Figma node 2311-262: lsicon:down-outline -->
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M24 30L10 16" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M24 30L38 16" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </section>

  <section class="benin-panel benin-panel--started">
    <div class="benin-panel__container">
      <h2>Where It Started</h2>
      <hr class="benin-panel__rule" />
      @for (paragraph of whereItStarted; track paragraph) {
        <p>{{ paragraph }}</p>
      }
    </div>
    <div class="benin-panel__globe">
      <img [src]="assets.africaGlobe" alt="Africa globe" />
    </div>
  </section>

  <div class="benin-model-story" [style.background-image]="'url(' + assets.mountainsDusk + ')'">
    <section class="benin-take-model">
      <div class="benin-take-model__block benin-take-model__block--model">
        <h2>The Model</h2>
        <div class="benin-take-model__copy">
          @for (paragraph of modelParagraphs; track paragraph) {
            <p>{{ paragraph }}</p>
          }
        </div>
      </div>
    </section>

    <section class="benin-cause-story">
      <div class="benin-cause-story__container">
        <h2>A CAUSE FOR ZUMERA</h2>
        <blockquote>“We Are Revealing Africa's Power, Freedom and Beauty To The World Through A New Standard of Peerless Hospitality.”</blockquote>

        <div class="benin-cause-story__paragraphs">
          @for (paragraph of narrativeParagraphs; track paragraph) {
            <p>{{ paragraph }}</p>
          }
        </div>
      </div>
    </section>

    <section class="benin-kingdom">
      <div class="benin-kingdom__container">
        <h2>THE KINGDOM OF BINI</h2>
        <img [src]="assets.entertainmentBg" alt="Aerial view of Benin City" />
      </div>
    </section>

    <section class="benin-vision-detail">
      <div class="benin-vision-detail__background" [style.background-image]="'url(' + assets.visionBg + ')'" aria-hidden="true"></div>
      <div class="benin-vision-detail__container">
        <h2>WHERE OUR VISION BEGINS</h2>
        @for (paragraph of visionParagraphs; track $index) {
          <p [innerHTML]="paragraph"></p>
        }
      </div>
    </section>
  </div>

  <section class="benin-ubinu">
    <div class="benin-ubinu__container">
      <div class="benin-ubinu__lead">
        <h2>OUR QUEST TO REVEAL THE SOUL OF BENIN CITY</h2>
        <div class="benin-ubinu__copy">
          <h3>ZUMERA: UBINU</h3>
          <div class="benin-ubinu__body">
            @for (paragraph of ubinuParagraphs; track paragraph) {
              <p>{{ paragraph }}</p>
            }
          </div>
        </div>
      </div>

      <div class="benin-ubinu__chapter">
        <span>Chapter One</span>
        <strong>ZUMERA EWEKA</strong>
        <em>The Soul of the King</em>
      </div>
    </div>
  </section>

  <section class="benin-rj-banner" aria-label="Zumera Eweka">
    <img [src]="assets.zumeraEwekaLogo" alt="Zumera Eweka" />
  </section>

  <section class="benin-eweka-story">
    <div class="benin-eweka-story__container">
      <p>Every civilisation is shaped by its leadership in one way or another, and for Benin, in more ways than one. The identity of shared royalty began long before the Oba and became even more deeply understood after one particular Oba made it unmistakably clear: Oba Eweka I.</p>
      <p>Zumera Eweka reveals the royalty of Benin through the philosophy, vision, and legacy of the Oba who preserved and strengthened the identity of the people of this land. It stands as an invitation to experience the philosophy that shaped one of Africa’s greatest kingdoms and the values that have defined Bini civilization for centuries.</p>
      <p>Hence, the first story we tell is the story of the King.</p>
      <h2>A CAUSE FOR ZUMERA EWEKA (BENIN CITY)</h2>
      <p>We Are Revealing the Power, Freedom and Beauty of Benin City To The World Through A New Standard of Peerless Hospitality. Our first chapter in this mission is ZUMERA EWEKA (BENIN CITY): An Ultra-luxury BOUTIQUE HOTEL.</p>
    </div>
  </section>

  <!-- Project description and relaunch status -->
  <section class="benin-project">
    <div class="benin-project__container">
      <div class="benin-project__grid">
        <div class="benin-project__left">
          <div class="benin-project__gold-rule benin-project__gold-rule--short"></div>
          <div class="benin-project__item">
            <span class="benin-project__label">Project Name:</span>
            <h3 class="benin-project__value">ZUMERA EWEKA (BENIN CITY): AN ULTRA-LUXURY BOUTIQUE HOTEL.</h3>
          </div>
          <div class="benin-project__item">
            <span class="benin-project__label">Debuting:</span>
            <h3 class="benin-project__value">2nd Q. 2028</h3>
          </div>
        </div>

        <div class="benin-project__right">
          <div class="benin-project__gold-rule benin-project__gold-rule--long"></div>
          <h3 class="benin-project__desc-header">PROJECT DESCRIPTION:</h3>
          <p>
            Our flagship project, Eweka, is named after the first Oba (King) of the Benin Kingdom. He established the Obaship of the kingdom, an institution that has endured to this day.
          </p>
          <p>
            His philosophy was simple: royalty exists in everyone. Therefore, to govern royalty, you must first be one yourself. You must speak their language, understand them, and build for them from within their own culture. Only then can you truly reign.
          </p>
          <p>Hence, ZUMERA EWEKA means:</p>
          <p>&ldquo;The Soul of the King.&rdquo;</p>
          <p>
            It will be a development created as an Elegant Hospitality and Entertainment Destination for discerning guests to play and relax.
          </p>
          <p>
            ZUMERA EWEKA (Benin City): An Ultra-Luxury Boutique Hotel, will be designed to appeal to and attract those who do not currently visit Benin City, as well as everyone who already does. It is meant to be a place of class in a very real sense. A true picture of this seven-century-old city&rsquo;s identity and heritage, which has always been Power, Freedom, and Beauty. The freedom to become whoever you want to be, however you want to be it, and whenever you choose to be it. That is true Royalty.
          </p>
          <p>
            A Symbol of Greatness. The loveliest, most elegant, and most beautiful hotel ever built in history. Think: &quot;Everything beautiful.&quot;
          </p>
          <p>
            Ultra-Luxury. Class. Hospitality. An unforgettable experience.
          </p>
        </div>
      </div>
    </div>
  </section>

  <!-- Scroll Banner: End-to-end full bleed -->
  <section class="benin-scroll-banner">
    <div class="benin-scroll-banner__container">
      <img [src]="assets.scrollQuote" alt="Zumera Eweka is special, created in a special place for special people. — Lucky R. Erherha —" class="benin-scroll-banner__img" />
    </div>
  </section>

  <!-- Relaunch status and pipeline -->
  <section class="benin-project-relaunch">
    <div class="benin-project__container">
      <div class="benin-project__bottom">
        <h2 class="benin-project__relaunch">RELAUNCHING SOON.</h2>
        <div class="benin-project__pipeline">
          <span class="benin-project__pipeline-label">Chapter Two</span>
          <h2 class="benin-project__pipeline-title">TO BE LAUNCHED.</h2>
        </div>
      </div>
    </div>
  </section>

</main>

<app-figma-benin-footer></app-figma-benin-footer>
